import styles from "./Icon.module.scss";

type IconFamily = "regular" | "bold" | "fill" | "light" | "thin";
type IconSize = "lg" | "md" | "sm" | "xs" | "xxs";
type IconVariant = "brand" | "neutral" | "error" | "warning" | "success";

interface IIconProps {
    /**
     * The optional button ID.
     */
    id?: string;

    /**
     * An ID to target in frontend tests.
     */
    dataCy?: string;

    /**
     * The size of the icon.
     */
    size?: IconSize;

    /**
     * The color of the icon
     */
    colorVariant?: IconVariant | "icon-inverse";

    /**
     * The icon we want to apply the the size and color change to
     */
    children: JSX.Element;
}

function Icon({ id, dataCy, size = "md", colorVariant, children }: Readonly<IIconProps>): JSX.Element {
    return (
        <span
            id={id}
            data-cy={dataCy}
            className={`${styles.iconBase} ${styles[size] ?? styles.default} ${colorVariant ? styles[colorVariant] : ""}`}
        >
            {children}
        </span>
    );
}

export { Icon, IconFamily, IconSize, IconVariant, IIconProps };
